import { TCaptchaScene } from '../types/index';

export const T_CAPTCHA_SCRIPT_URL = 'https://global.captcha.gtimg.com/TCaptcha-global.js';
/**
 *  防水墙场景和对应APPID配置
 */
export const TCaptchaConfig = {
  [TCaptchaScene.prom]: '188938319',
};

